import React, { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";

const QRCodeGenerator = ({ value, size = 256, level = "H" }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      setIsLoaded(true);
    } catch (err) {
      setError(err);
      console.error("Error generating QR code:", err);
    }
  }, [value]);

  if (error) {
    return <div>Error generating QR code</div>;
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <QRCodeCanvas 
      value={value} 
      size={size} 
      level={level}
      onError={(err) => {
        setError(err);
        console.error("QR Code error:", err);
      }}
    />
  );
};

export default QRCodeGenerator;
